import {
  Datatype,
  type FieldDatatype,
} from '../../../../schema/expressions/datatype/Datatype.ts';

// Tenere allineati con enumAnagraficaPlaceholderDtoCategory in api-client
export const placeholderCategories = [
  'PROCEDIMENTO',
  'USER_TASK',
  'SEZIONE_BACKOFFICE',
  'SEZIONE_FRONTOFFICE',
  'TIPO_DOCUMENTO',
  'TIPO_COMUNICAZIONE',
  'PRATICA',
  'RECORD_ALBO',
  'SALVA_IN_TABELLA',
  'FUNZIONE',
  'DOMANDA',
  'ALTRO',
] as const;
export type PlaceholderCategory = (typeof placeholderCategories)[number];
export enum PlaceholderCategoryEnum {
  Procedimento = 'PROCEDIMENTO',
  UserTask = 'USER_TASK',
  SezioneBackoffice = 'SEZIONE_BACKOFFICE',
  SezioneFrontoffice = 'SEZIONE_FRONTOFFICE',
  TipoDocumento = 'TIPO_DOCUMENTO',
  TipoComunicazione = 'TIPO_COMUNICAZIONE',
  Pratica = 'PRATICA',
  RecordAlbo = 'RECORD_ALBO',
  SalvaInTabella = 'SALVA_IN_TABELLA',
  Funzione = 'FUNZIONE',
  Domanda = 'DOMANDA',
  Altro = 'ALTRO',
}

// Tenere allineati con enumAnagraficaPlaceholderDtoType in api-client
export const placeholderTypes = ['STRING', 'NUMBER', 'IMAGE', 'HTML'] as const;
export type PlaceholderType = (typeof placeholderTypes)[number];
export enum PlaceholderTypeEnum {
  String = 'STRING',
  Number = 'NUMBER',
  Image = 'IMAGE',
  Html = 'HTML',
}

export const parameterTypes = [
  'STRING',
  'NUMBER',
  'ID_USER_TASK',
  'ID_SEZIONE_BACKOFFICE',
  'ID_SEZIONE_FRONTOFFICE',
  'ID_TIPO_DOCUMENTO',
  'ID_TIPO_COMUNICAZIONE',
] as const;
export type ParameterType = (typeof parameterTypes)[number];
export enum ParameterTypeEnum {
  String = 'STRING',
  Number = 'NUMBER',
  IdUserTask = 'ID_USER_TASK',
  IdSezioneBackoffice = 'ID_SEZIONE_BACKOFFICE',
  IdSezioneFrontoffice = 'ID_SEZIONE_FRONTOFFICE',
  IdTipoDocumento = 'ID_TIPO_DOCUMENTO',
  IdTipoComunicazione = 'ID_TIPO_COMUNICAZIONE',
}

export interface PlaceholderParameter {
  id: string;
  type: ParameterType;
  label?: string;
}

// Tenere allineati con AnagraficaPlaceholderDto in api-client
export interface PlaceholderReference {
  code: string;
  label: string;
  description: string;
  category: PlaceholderCategory;
  parameters: PlaceholderParameter[];
  examples: string[];
  type: PlaceholderType;
}

export interface PlaceholderMetadata {
  label?: string;
  description?: string;
  examples?: string[];
}

export type PlaceholderMetadataRegistry = Record<string, PlaceholderMetadata>;

export function mapPlaceholderTypeToField(
  type: PlaceholderType,
): FieldDatatype {
  switch (type) {
    case PlaceholderTypeEnum.Number:
      return { type: Datatype.Number };
    case PlaceholderTypeEnum.String:
    case PlaceholderTypeEnum.Image:
    case PlaceholderTypeEnum.Html:
    default:
      return { type: Datatype.String };
  }
}
